import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
//import Paper from '@material-ui/core/Paper';
//import Grid from '@material-ui/core/Grid';
//
//
// NOT DONE.
// = The just need this for falcon. The plan is the data will be saved on the invoice (locked in) and
//= then passed here so it can be used to print out hte graphical formula
//
//

import StationInvoiceContainer from '../../containers/accounting/StationInvoice';
import pfLogo from '../../images/pearsonFuelsLogoV2.png';
//import StationInvoiceForPdf from "../../components/StationInvoiceForPdf";

const styles = () => {
	const p = (v) => {
		return `${v * 100}%`;
	};
	const pBlue = '#0790CB';
	const lineColor = '#D9D9D9';
	const rowLineColor = '#f1f1f1';

	return {
		root: {
			position: 'absolute',
			backgroundColor: 'white',
			height: '100%',
			width: '100%',
		},
		container: {
			position: 'relative',
			height: '100%',
			width: '100%',
			padding: `${p(0.065)} ${p(0.075)}`,
			boxSizing: 'border-box',
			fontFamily: 'Roboto',
			color: '#666',
			fontSize: '1.8vw',
		},
		containerWrapper: {
			position: 'relative',
			height: '100%',
			width: '100%',
			//border : '1px solid red',
		},

		logo: {
			marginTop: p(0.02),
			width: p(0.52),
			//height : p(0.),
		},

		formulaName: {
			fontSize: '130%',
			fontWeight: 900,
		},
		formulaUpdated: {
			fontWeight: 200,
			color: '#999',
		},
		formulaTitle: {
			textTransform: 'uppercase',
			color: '#999',
			paddingBottom: 10,
		},
		formulaRow: {
			display: 'flex',
			flexDirection: 'row',
			paddingBottom: 2,
		},
		formulaTotal: {
			borderTop: '2px solid #ccc',
			paddingTop: '5px',
			marginTop: '5px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
			paddingBottom: '15px',
		},
		formulaSubtotal: {
			marginLeft: '10%',
			marginRight: '10%',
			borderTop: '1px solid #ddd',
			paddingTop: '5px',
			marginTop: '5px',
			paddingBottom: '15px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
		},
		bigInvoiceContainer: {
			marginTop: '9%',
			borderTop: `1px solid ${lineColor}`,
			borderBottom: `1px solid ${lineColor}`,
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			padding: '1% 0%',
			lineHeight: '1.4',
		},
		bigInvoice: {
			fontSize: '6.2vw',
			fontWeight: 100,
			color: pBlue,
			flexBasis: '50%',
		},
		billingInfo: {
			textAlign: 'left',
			marginRight: '3%',
			flexBasis: '50%',
		},
		label: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
		},
		itemSection: {
			marginTop: '12%',
			width: '60%',
			marginLeft: '25%',
			fontSize: '100%',
		},
		labelLine: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			textTransform: 'uppercase',
		},
		colDescription: {
			flexBasis: '80%',
			textAlign: 'left',
		},
		colQuantity: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		colUnitCost: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		colSubTotal: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		itemRow: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${rowLineColor}`,
			paddingTop: '.9vw',
			paddingBottom: '.9vw',
			//letterSpacing : '.1em',

			paddingRight: '1vw',
			paddingLeft: '1vw',
		},

		rowSubTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${lineColor}`,
			paddingTop: '.9vw',
			paddingBottom: '.9vw',
			//letterSpacing : '.1em',
			fontWeight: 900,
			marginBottom: '2vw',

			paddingRight: '1vw',
			paddingLeft: '1vw',
		},

		rowTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${pBlue}`,
			paddingTop: '1.5vw',
			paddingBottom: '1.5vw',
			//letterSpacing : '.1em',
			fontWeight: 900,
			marginBottom: '2vw',
			fontSize: '110%',
			backgroundColor: '#f8f8f8',
			paddingRight: '1vw',
			paddingLeft: '1vw',
		},

		miniTotalSection: {
			display: 'flex',
			flexDirection: 'row',
			textAlign: 'right',
			justifyContent: 'flex-end',
			marginTop: '3%',
		},
		poInfo: {
			marginTop: '6%',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
		},
		poGroup: {
			flexGrow: 1,
			marginRight: '6%',
			'&:last-child': {
				marginRight: '0%',
			},
		},
		poLabel: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			textTransform: 'uppercase',
			marginBottom: '.5vw',
		},

		formulaLabel: {
			color: '#333',
			flexBasis: '50%',
			textAlign: 'right',
			paddingRight: '8px',
		},
		formulaValue: {
			color: '#666',
			flexBasis: '50%',
			textAlign: 'left',
		},

		bottomSection: {
			position: 'absolute',
			bottom: '0%',
			width: '100%',
			marginBottom: '2%',
		},

		termAndTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			marginTop: '.8%',
		},
		termParagraph: {
			fontSize: '92%',
			color: '#999999',
			textAlign: 'left',
			fontWeight: 200,
			flexBasis: '100%',
		},
	};
};

class StationInvoice extends Component {
	constructor(props) {
		super(props);
		const stationInvoiceId = _.get(this.props, ['match', 'params', 'stationInvoiceId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			stationInvoiceId: stationInvoiceId ? parseInt(stationInvoiceId, 10) : undefined,
			securityHash,
			errors: [],
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { publicGetStationInvoice, stationInvoice } = this.props;
		const { stationInvoiceId, securityHash } = this.state;
		if (stationInvoice) {
			return;
		}

		publicGetStationInvoice({
			params: {
				stationInvoiceId,
				securityHash,
				includeQuickbooksCustomers: true,
				includeQuickbooksTerms: true,
			},
		});

		/*
			callback : (err, r) => {
				if (err) { return this.setState({ errors : [err] }); }
				const stationInvoice = _.get(r, ['collections', 'stationInvoiceCollection', 0]);
				if (!stationInvoice) { return {errors : ['Missing station invoice.']}; }




				return this.setState({ stationInvoice });
			}
		});
			*/
	}

	getDataDumpData = () => {
		const { stationInvoice, stationQuotedPriceMap, dataDumpMap } = this.props;

		if (!stationInvoice) {
			return { error: 'Missing station invoice. Contact support.' };
		}

		const { stationQuotedPriceId } = stationInvoice;
		if (!stationQuotedPriceId) {
			return { error: 'Missing quoted price. Contact support.' };
		}

		const stationQuotedPrice = stationQuotedPriceMap[stationQuotedPriceId];

		if (!stationQuotedPrice) {
			return { error: 'Could not find station quoted price in map. Contact support.' };
		}

		const { dataDumpId } = stationQuotedPrice;
		if (!dataDumpId) {
			return { error: 'Quoted price missing data dump. This estimate cant be used. Sorry.' };
		}

		const dataDump = dataDumpMap[dataDumpId];
		if (!dataDump) {
			return { error: 'Could not get data from dataDumpMap' };
		}

		return { data: dataDump.data };
	};

	render() {
		const { classes, stationInvoice } = this.props;

		if (!stationInvoice) {
			return <div>Fetching station invoice...</div>;
		}

		const { error, data } = this.getDataDumpData();

		if (error) {
			return (
				<div>
					<div>Encountered an error when retrieving the data for formula</div>
					<div>{error}</div>);
				</div>
			);
		}

		const _f = (v) => {
			return parseFloat(v.toFixed(5));
		};

		const laEth = _f(data.laEth);
		const etohAdjustment = 0.15; // etoh adjustment
		const ethSubtotal = _f(laEth + etohAdjustment);

		//const c = (a + b) * 0.83;
		const ubdRackAvg = _f(data.ubdRackAvg);
		const capAtTheRack = _f(data.capAtTheRack);
		const lcfsCost = _f(data.lcfsCost);
		const unlSubtotal = _f(data.ubdRackAvg + data.capAtTheRack + data.lcfsCost);

		const ethSubtotalP = _f(ethSubtotal * 0.83);
		const unlSubtotalP = _f(unlSubtotal * 0.17);
		const adjustment = 0.08;
		const total = _f(ethSubtotalP + unlSubtotalP - adjustment);

		// Create our number formatter.
		const moneyFormatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 4,
			// the default value for minimumFractionDigits depends on the currency
			// and is usually already 2
		});

		const lineItems = [
			{ description: 'LA Spot Ethanol Cost', value: laEth },
			{ description: 'ETOH Adjustment', value: etohAdjustment },
			{ description: 'Subtotal A', value: ethSubtotal, isSubtotal: true },

			{ description: 'LA Carb 87 Rack Average', value: ubdRackAvg },
			{ description: 'LA Cap & Trade Midrange', value: capAtTheRack },
			{ description: 'LA LCFS Cost', value: lcfsCost },
			{ description: 'Subtotal B', value: unlSubtotal, isSubtotal: true },

			{ description: 'Subtotal A x 0.83', value: ethSubtotalP },
			{ description: 'Subtotal B x 0.17', value: unlSubtotalP },
			{ description: 'Adjustment', value: adjustment },
			{ description: 'Wholesale E85 Price', value: moneyFormatter.format(total), isTotal: true },
		];

		return (
			<div className={classes.root}>
				<div className={classes.container}>
					<div className={classes.containerWrapper}>
						<img alt="Logo" className={classes.logo} src={pfLogo} />

						<div className={classes.bigInvoiceContainer}>
							<div className={classes.bigInvoice}>FORMULA</div>
							<div className={classes.billingInfo}>
								<div className={classes.formulaName}>E85 Pricing Formula for Falcon Fuels</div>
								<div className={classes.formulaUpdated}>Updated to include LCFS fee expense</div>
								<div className={classes.formulaUpdated}>Revision Date: 3/16/2016</div>
							</div>
						</div>

						<div className={classes.itemSection}>
							<div className={classes.labelLine}>
								<div className={classes.colDescription}>DESCRIPTION</div>
								<div className={classes.colQuantity}>VALUE</div>
							</div>

							{lineItems.map((lineItem, i) => {
								const { description, value, isTotal, isSubtotal } = lineItem;

								const className = isSubtotal ? 'rowSubTotal' : isTotal ? 'rowTotal' : 'itemRow';

								return (
									<div key={i} className={classes[className]}>
										<div className={classes.colDescription}>{description}</div>
										<div className={classes.colQuantity}>{value}</div>
									</div>
								);
							})}
						</div>

						<div className={classes.bottomSection}>
							<div className={classes.labelLine}>
								<div>Terms &amp; Conditions</div>
							</div>
							<div className={classes.termAndTotal}>
								<div className={classes.termParagraph}>
									- Freight will be charged additional (Freight is often slightly more than common
									carriers due to the fact that the truck must make two stops at two fuel racks).
									<br />
									<br />- Prices do not include any taxes including the $.09 Vendor Use Tax that is
									to be paid when the E85 is dispensed into the vehicles.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

StationInvoice.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func,

	//- Batch
	publicGetStationInvoice: PropTypes.func,
	stationInvoice: PropTypes.object,
	stationQuotedPriceMap: PropTypes.object,
	dataDumpMap: PropTypes.object,
	stationMap: PropTypes.object,
};

export default _.flow([withStyles(styles), StationInvoiceContainer])(StationInvoice);
